import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { SharedModule } from '../../../core/modules/shared.module';


import { ReimpresionFacturaIndexComponent } from './ReimpresionFacturaIndex.component';
import { RoleGuardService as RoleGuard } from './../Seguridad/role-guard.service';


const routes = [
{
	path 	 : 'ReimpresionFacturas',
	component: ReimpresionFacturaIndexComponent,
	canActivate: [RoleGuard], 
	data: { 
		formulario: 'ReimpresionFacturas',
        nombreFormulario : 'Reimprimir Facturas'
	} 
}];


@NgModule({
	declarations: [
	ReimpresionFacturaIndexComponent
	],
	imports     : [
	SharedModule,
	RouterModule.forChild(routes)
	],
	exports  : [
	ReimpresionFacturaIndexComponent

	]
})


export class ReimpresionFacturaModule
{
}


// WEBPACK FOOTER //
// D:/Repositorios/FacturacionWeb/src/app/main/content/ReimpresionFactura/ReimpresionFactura.module.ts